var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "imc_load" },
    [
      _c("file-pond", {
        ref: "pond",
        attrs: {
          name: "getorder_loader",
          "allow-multiple": "true",
          server: _vm.getConfig(),
          "label-idle": _vm.__t("PUSH_FILE_LOADER"),
          files: _vm.myFiles,
        },
        on: { activatefile: _vm.openFile, init: _vm.handleFilePondInit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }